import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Loader({ onDone }) {
  const [progress, setProgress] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    let val = 0;
    const id = setInterval(() => {
      val += Math.random() * 9 + 4;
      if (val >= 100) {
        val = 100;
        clearInterval(id);
        setProgress(100);
        setTimeout(() => {
          setDone(true);
          onDone?.();
        }, 500);
      } else {
        setProgress(Math.floor(val));
      }
    }, 90);
    return () => clearInterval(id);
  }, [onDone]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="loading-screen"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[#171717]"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.7, ease: [0.76, 0, 0.24, 1] } }}
        >
          {/* Animated rings */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-[420px] h-[420px] rounded-full border border-white/5 floaty" />
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-[260px] h-[260px] rounded-full border border-cyan-400/20 floaty-2" />
          </div>

          <div className="relative flex flex-col items-center gap-10 px-6">
            <div className="overline">Initializing Studio</div>
            <div className="font-display text-7xl md:text-8xl text-white tabular-nums">
              {String(progress).padStart(3, "0")}
              <span className="text-[#FD1843]">%</span>
            </div>
            <div className="relative w-[280px] md:w-[420px] h-[2px] bg-white/10 overflow-hidden">
              <motion.div
                className="absolute inset-y-0 left-0 bg-[#FD1843]"
                animate={{ width: `${progress}%` }}
                transition={{ ease: "easeOut", duration: 0.3 }}
                style={{ boxShadow: "0 0 18px rgba(253,24,67,0.7)" }}
              />
            </div>
            <div className="font-mono text-[10px] tracking-[0.28em] text-white/40 uppercase">
              Basit Loay — Design Studio
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
